import { MuiTypography } from "@/components/ui/mui-typography";
import { maxPriceText, type MaxPriceLabel } from "@/lib/target-cost-display";

// The Item Search card's max-price chip (#1216) — the donor's `ItemMaxPrice`
// (`items/shared/components/item-max-price.tsx`), drawn by `ItemMetadata`
// between the item's name and its `Category` line while the editor's switch is
// on (`ItemCard.tsx:350-354`). A domain component of the donor's `items/shared`,
// not a `react-ui` one, and only the Item Search face draws it, so it lives
// here beside the item badges.
//
// `HStack spacing={1} alignItems='center'` rendered as a `body2` Typography: a
// `<p>` flex row, 8px apart, padded 4px 8px, radius 4, black on `#e0f1fe`,
// `min-content` wide and `nowrap`. Its label is a plain span and its price a
// `<strong>`.

interface ItemMaxPriceProps {
  /** The item's `maxPrice` as the wire carries it, a fixed-scale string. */
  maxPrice: string | null | undefined;
  /** The editor's switch (`showTargetCost`). */
  show: boolean;
  /** `maxPriceLabel`'s answer for the item's category. */
  label: MaxPriceLabel;
}

export function ItemMaxPrice({ maxPrice, show, label }: ItemMaxPriceProps) {
  const price = maxPriceText(maxPrice);
  if (!show || price === null) return null;
  return (
    <MuiTypography
      variant="body2"
      data-testid="item-max-price"
      className="bg-catalog-max-price flex w-min items-center gap-2 rounded-[4px] px-2 py-1 whitespace-nowrap text-black"
    >
      <span>{label}</span>
      <strong>{price}</strong>
    </MuiTypography>
  );
}
